import styled from 'styled-components';
import type { ThemeTypes } from '../../../types/Theme.namespace';

const BulletedList = styled.ul<{
  $color: ThemeTypes.Colors;
  $gap?: ThemeTypes.Spacing;
}>`
  list-style: none;
  display: flex;
  flex-direction: column;
  color: ${({ theme, $color }) => theme.colors[$color]};
  ${({ theme, $gap }) => $gap && `gap: ${theme.spacing[$gap]}`};
`;

export { BulletedList };
